import React from 'react';
import { useTranslation } from 'react-i18next';
import { Image, StyleSheet, Text, View } from 'react-native';

import { chipImgOne, ChipsBackgrOne, goldChipIcon, UnderTitleLight } from '../../../../assets';
import Loader from '../../../../shared/Loader';
import { Package } from '../../../../store/types';
import { useSafeViewport } from '../../../../utils/hooks/useSafeViewport';
import ChipCard from './ChipCard';
import ChipCardDesktop from './ChipCardDesktop';

interface ChipScreenProps {
	chipPackages: Package[];
	onPayment: (pkg: Package) => void;
}

const ChipScreen: React.FC<ChipScreenProps> = ({ chipPackages, onPayment }) => {
	const { width } = useSafeViewport();
	const { t } = useTranslation();
	const shouldUseMobileLayout = width < 1000;
	const isLoading = chipPackages.length === 0;

	return (
		<View>
			{shouldUseMobileLayout ? (
				<View style={styles.mobileLayout}>
					{isLoading ? (
						<View style={styles.loaderSpace}>
							<Loader />
						</View>
					) : (
						<>
							<Text style={styles.tournamentTitle}>{t('T_SITE_PROFILE_BUY')}</Text>
							<Image source={UnderTitleLight} style={styles.titleLight} />
							{chipPackages.map(item => {
								return (
									<ChipCard
										key={item.id}
										pkg={item}
										pkgImg={chipImgOne}
										chipImg={goldChipIcon}
										amount={Number(item.chipAmount) || 0}
										price={Number(item.price) || 0}
										onPayment={onPayment}
									/>
								);
							})}
						</>
					)}
				</View>
			) : (
				<View style={styles.desktopContainer}>
					<View style={styles.gridContainer}>
						<View style={styles.gridWrapper}>
							{isLoading ? (
								<View style={styles.loaderSpace}>
									<Loader />
								</View>
							) : (
								<View style={styles.packagesGrid}>
									{chipPackages.map(item => {
										return (
											<View key={item.id} style={styles.packageWrapper}>
												<ChipCardDesktop
													vipIcon={chipImgOne}
													borderColor='#C0C0C0'
													textColor='#FFD700'
													vipLabel={goldChipIcon}
													chipBackground={ChipsBackgrOne}
													amount={Number(item.chipAmount) || 0}
													price={Number(item.price) || 0}
													pkg={item}
													onPayment={onPayment}
												/>
											</View>
										);
									})}
								</View>
							)}
						</View>
					</View>
				</View>
			)}
		</View>
	);
};

const styles = StyleSheet.create({
	mobileLayout: {
		width: '100%',
		maxWidth: '80%',
		alignSelf: 'center',
		maxHeight: '100%',
		flex: 1,
		minHeight: 0,
		rowGap: 10,
		justifyContent: 'flex-start',
		alignContent: 'center',
	},
	desktopContainer: {
		width: '100%',
	},
	gridContainer: {
		padding: 15,
		alignItems: 'center',
	},
	gridWrapper: {
		maxWidth: 700,
		width: '100%',
	},
	packagesGrid: {
		flexDirection: 'row',
		flexWrap: 'wrap',
		justifyContent: 'flex-start',
		columnGap: 10,
		rowGap: 10,
	},

	packageWrapper: {
		width: '32%',
		marginBottom: 0,
	},
	loaderSpace: {
		minHeight: 320,
		justifyContent: 'center',
		alignItems: 'center',
	},
	tournamentTitle: {
		fontWeight: '900',
		color: '#d8d8d8',
		textAlign: 'center',
		marginVertical: 12,
		textShadowColor: '#000',
		textShadowOffset: { width: 1, height: 2 },
		textShadowRadius: 3,
		letterSpacing: 1,
		textTransform: 'uppercase',
	},
	titleLight: {
		height: 4,
		width: '100%',
		marginBottom: 16,
	},
});

export default ChipScreen;
